// Per-TAB reconnect token — sessionStorage, not localStorage: the token is a bearer credential the server
// hands the most recent `hello` it saw (server.ts's handleHello), so two tabs sharing one via localStorage
// take turns displacing each other's connection, each reconnecting into the other's now-stolen-back
// session, forever, with no message — a real, permanent deadlock, not a testing artifact. sessionStorage
// is per-tab and still survives a reload of that same tab (the actual case reconnect exists for), so every
// tab is simply its own player. Wrapped in try/catch like sound.ts's mute flag, since storage throws in
// some private-browsing modes instead of just being empty.
const KEY = 'ashen-plate-token';

export function readToken(): string | null {
  try { return sessionStorage.getItem(KEY); } catch { return null; }
}

export function writeToken(token: string) {
  try { sessionStorage.setItem(KEY, token); } catch { /* private mode, ignore */ }
}
